import {FC} from 'react'
import ManagementDashboard from './ManagementDashboard'

const DashboardWrapper: FC = () => {
  return (
    <>
      <ManagementDashboard />
    </>
  )
}

export {DashboardWrapper}
export default DashboardWrapper
